import React from 'react';
import { Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';

// Section heading used by every report section. Sets minPresenceAhead so the
// title never renders at the bottom of a page when its content can't follow
// — @react-pdf will push the title to the next page if there isn't at least
// `minPresenceAhead` pt of room for the next sibling.
//
// The default 60pt is enough for one short card or two list rows. Sections
// with much larger first children (e.g. a full match card ~120pt) can pass
// a bigger value.
const SectionTitle = ({ children, minPresenceAhead = 60, style }) => (
  <Text
    minPresenceAhead={minPresenceAhead}
    style={[
      type.cardTitle,
      { color: colors.ink, marginBottom: space.sm },
      style,
    ]}
  >
    {children}
  </Text>
);

export default SectionTitle;
